// extracted by mini-css-extract-plugin
module.exports = {"smallBreakpoint":"600px","component":"TrustPilot_component__Fbij0"};